var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-content"},[_c('nuxt-content',{attrs:{"document":_vm.cleanDocument}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }